import { utils } from '../utils/utils';
import { HttpClient } from './serviceBase';

class PromotionsService {
    GetActives = async (businessId, branchId, dayName) => {
        const queryString = utils.GetQueryStringsFromObject({ businessId, branchId, dayName });
        return await HttpClient.Get(`/api/Promotions/info/active?${queryString}`);
    }

    GetAditionals = async (businessId, branchCode, country, productsIds = []) => {
        let queryString = `?businessId=${businessId}&branchCode=${branchCode}&country=${country}`;

        productsIds.forEach(productId => {
            queryString += `&productsIds=${productId}`
        });

        return await HttpClient.Get(encodeURI(`/api/promotions/aditionals${queryString}`));
    }
}

export default new PromotionsService();